import React, { useEffect, useState } from 'react'
import { Col, FormGroup, Input, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import Select from 'react-select'
import { textureOptions } from './constants'
import PropTypes from 'prop-types'
import { isNotAlpha, isNotNumericDecimal } from 'context/Utilities'

const PeanutButterPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    PBTexture: item.PBTexture,
    PBContainerSize: item.PBContainerSize,
  })

  const temp = {
    value: item.PBTexture,
    label: item.PBTexture,
  }

  const contains = textureOptions.some(e => {
    return JSON.stringify(temp) === JSON.stringify(e)
  })

  if (contains) {
    packaging.PBTexture = item.PBTexture
  } else {
    packaging.PBTexture = 'Other'
    packaging.otherTexture = item.PBTexture
    item.otherTexture = item.PBTexture
    item.PBTexture = 'Other'
  }

  const methods = useFormContext()
  const { setSelectReviewer, onChangeReviewer, asterisk } = useFormUtils()

  useEffect(() => {
    if (item !== null) {
      const { PBTexture, PBContainerSize } = item
      setPackaging({
        PBTexture,
        PBContainerSize,
      })
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <>
      <Row>
        <Col xs={6}>
          <p>
            <strong>Texture {asterisk}</strong>
          </p>
          <Controller
            as={Select}
            className="react-select primary"
            classNamePrefix="react-select"
            options={textureOptions}
            defaultValue={{
              label: packaging.PBTexture,
              value: packaging.PBTexture,
            }}
            name="PBTexture"
            control={methods.control}
            rules={{ required: true }}
            placeholder={'Select Texture'}
            onChange={([selected, value]) => {
              setSelectReviewer(item, selected, value)
              setPackaging({
                ...packaging,
                PBTexture: value,
              })
              return selected
            }}
            isDisabled={isDisabled}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="PBTexture"
              message={'⚠ Texture is required.'}
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
          <br />
          {item?.PBTexture === 'Other' && (
            <FormGroup>
              <p>
                <strong>Other Texture (Please Specify) {asterisk}</strong>
              </p>
              <Controller
                as={Input}
                name="otherTexture"
                placeholder={'Other Texture'}
                defaultValue={item.otherTexture}
                control={methods.control}
                rules={{ required: true }}
                onKeyDown={e => {
                  if (isNotAlpha(e.key) && e.key !== ' ') {
                    e.preventDefault()
                  }
                }}
                onChange={([event]) => {
                  onChangeReviewer(item, event)
                  return event
                }}
                disabled={isDisabled}
              />
              <p className={'text-danger'}>
                <ErrorMessage
                  errors={methods.errors}
                  name="otherTexture"
                  message={'Other texture is required.'}
                  as={<Alert color={'danger'} className={'mt-3'} />}
                />
              </p>
            </FormGroup>
          )}
        </Col>
        <Col xs={6}>
          <FormGroup>
            <p>
              <strong>Size {asterisk}</strong>
            </p>
            <Controller
              as={Input}
              name="PBContainerSize"
              placeholder={'16 - 18 ounces'}
              defaultValue={packaging.PBContainerSize}
              control={methods.control}
              rules={{
                validate: containerSize =>
                  containerSize >= 16 && containerSize <= 18,
                maxLength: {
                  value: 5,
                  message: '⚠ Size exceeds 5 characters.',
                },
              }}
              onKeyDown={e => {
                if (isNotNumericDecimal(e.key)) {
                  e.preventDefault()
                }
              }}
              onChange={([event]) => {
                onChangeReviewer(item, event)
                return event
              }}
              disabled={isDisabled}
            />
            <p className={'text-danger'}>
              <ErrorMessage
                errors={methods.errors}
                name="PBContainerSize"
                message={'⚠ Size must be between 16 - 18 ounces.'}
                as={<Alert color={'danger'} className={'mt-3'} />}
              />
            </p>
          </FormGroup>
        </Col>
      </Row>
    </>
  )
}

PeanutButterPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default PeanutButterPackageReview
